"use client";

import { ReactQueryClientProvider } from "@/lib/query-client-provider";
import GlobalErrorBoundary from "@/components/features/shared/GlobalErrorBoundary";
import CustomTopLoader from "@/components/features/shared/CustomTopLoader";
import { SessionProvider } from "next-auth/react";

export function Providers({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return (
    <SessionProvider>
      <ReactQueryClientProvider>
        <CustomTopLoader />
        <GlobalErrorBoundary>{children}</GlobalErrorBoundary>
      </ReactQueryClientProvider>
    </SessionProvider>
  );
}